module.exports = __webpack_public_path__ + "img/folder-add.f7451fb9.svg";